<div class="w-full h-screen">
    <router-outlet></router-outlet>
</div>
